import { configureStore } from '@reduxjs/toolkit'
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query'
import { postsEndpoints } from '../apiCaller/apis/postApi' 
import { briefIdSplice } from './splices'

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [postsEndpoints.reducerPath]: postsEndpoints.reducer,
    briefId: briefIdSplice.reducer,
   
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    
      getDefaultMiddleware().concat(postsEndpoints.middleware)
      // getDefaultMiddleware().concat(identityPostsEndpoints.middleware)
    
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)